import React, { useEffect, useState } from 'react';
import "./index.scss";

const HexagonalProgress = ({ progress }) => {
  useEffect(() => {
    const segments = document.querySelectorAll('.segment');

    function updateProgress(progress) {
      const FACTOR = 16.666666666666667; // 100/6
      const BASE_COLOR = 'black';
      segments.forEach((segment, index) => {
        const maxProgress = (index + 1) * FACTOR;
        const prevProgress = index * FACTOR;

        if (progress > maxProgress) {
          segment.style.background = 'transparent';
          let start = segment.querySelector('.start');
          start.style.width = '100%';
        } else if (progress <= maxProgress && progress > prevProgress) {
          const fill = (progress - prevProgress) / FACTOR * 100;
          segment.style.background = BASE_COLOR;
          let start = segment.querySelector('.start');
          start.style.width = `${fill < 20 ? 20 : fill}%`;
        } else {
          segment.style.background = BASE_COLOR;
          let start = segment.querySelector('.start');
          start.style.width = '0px';
        }
      });
    }

    updateProgress(progress);
  }, [progress]);

  return (
    <div className="hexagon-container">
      {Array.from({ length: 6 }).map((_, index) => (
        <div className="segment" key={index}>
          <div className="start"></div>
        </div>
      ))}
    </div>
  );
};

export default HexagonalProgress;
